import { LOADING } from "./types";

export const setIsLoading = (value) => (dispatch) => {
  dispatch({ type: LOADING, payload: value });
};
